<template>
    <v-dialog
            v-model="dialog"
            persistent
            max-width="320"
    >
        <v-card>
            <v-card-title
                    v-text="prompt.title"
            ></v-card-title>
            <v-card-text
                v-if="prompt.text"
                v-html="prompt.text.replace(/\n/g, '<br>')"
            ></v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                        text
                        @click="abort"
                >
                    {{ $t(prompt.btnDecline) }}
                </v-btn>
                <v-btn
                    text
                    color="error"
                    @click="execute"
                >
                    {{ $t(prompt.btnAccept) }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Prompt',
    computed: {
      ...mapGetters({
        prompt: 'prompt/getPrompt'
      }),
      dialog: {
        get() {
          return this.prompt.show
        },
        set() {
          this.$store.commit('prompt/closePrompt')
        }
      }
    },
    methods: {
      abort () {
        if (this.prompt.abortCallback)
          this.prompt.abortCallback()

        this.$store.commit('prompt/closePrompt')
      },
      execute () {
        this.prompt.execCallback()

        this.$store.commit('prompt/closePrompt')
      }
    }
  }
</script>

<style scoped>

</style>
